import React, { useState } from 'react'
import { View } from 'react-native'
import { useDispatch } from 'react-redux'
import ActionCreators from '../../store/actions'

import styles from './styles'
import { HGText, HGButton, HGHeading } from '../HGUI'
import HGModalFull from './HGModalFull'
import patientGroups from '../../config/patientGroups'

type Props = unknown

const ModalPatientGroup = (props: Props) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const _handleSetPatientGroup = (patientGroup: string) => {
    if (loading) return

    setLoading(true)
    setLoading(false)
    dispatch(ActionCreators.setPatientGroup({ patientGroup }))
    // .then(
    //   (/* result */) => {
    //     _navigateTo('SignedIn', dispatch)
    //   }
    // )
  }

  const _renderChoice = () => {
    return patientGroups
      .filter((p) => p.enabled)
      .map((p) => {
        return (
          <HGButton
            title={p.label}
            onPress={() => _handleSetPatientGroup(p.id)}
            style={styles.actionButton}
            key={`patiengroup-${p.id}`}
          />
        )
      })
  }

  return (
    <HGModalFull {...props} onRequestClose={() => {}}>
      <View style={styles.patientContainer}>
        <HGHeading>Bitte wählen Sie eine Patientengruppe aus</HGHeading>

        <HGText style={styles.secondaryText}>
          Sie können jederzeit die Patientengruppe unter Einstellungen wechseln.
        </HGText>

        <View style={styles.actionBox}>
          {_renderChoice()}

          {/* <HGButton
              title={ 'Reset' }
              onPress={ () => _handleSetPatientGroup(null) }
              style={ styles. actionButton }
              type={'inverted'}
            /> */}
        </View>
      </View>
    </HGModalFull>
  )
}

export default ModalPatientGroup
